import { TargetAudienceGenderEnum } from "../../../features/surveys-requests/models/enums/TargetAudienceGenderEnum"
import { QuestionTypeCodeEnum } from "./QuestionsList"

export class SurveyResponseDetails {
  responseId: number
  responseNumber: string
  status: string
  submittedDate: string
  respondentsName: string
  respondentsGender: TargetAudienceGenderEnum
  respondentsRegion: string
  respondentsAge: number
  isLessThanMinimumCompletionTime: boolean
  isRespondentAgeNotInRange: boolean
  canUpdate: boolean
  canReject: boolean
  canApproved: boolean
  canDelete: boolean
  answers: Answer[]
}

export class Answer {
  questionId: number
  questionTitle: string
  questionOrder: number
  surveyAndOpinionPollQuestionTypeId: number
  questionTypeCode: QuestionTypeCodeEnum
  questionType: string
  textAnswer?: string
  selectedOptionId?: number
  selectedOptionText?: string
  selectedOptionIds: number[]
  selectedOptionTexts: string[]
  starRating: any
  attachmentUrls: AttachmentUrl[]
}

export class AttachmentUrl {
  id: number
  path: string
  name: string
  extention: string
  size: number
}
